
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Typography, Avatar } from '@material-ui/core';
import Apis from '../../network/Apis';
import SubscribeItem from './view/SubscribeItem';
import Swiper from 'react-id-swiper';
import MatchItem from '../match/view/MatchItem';
import DateUtils from '../../control/dateutils';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';
import Match from '../../model/Match';
import Live from '../../model/Live';

const ICON_TITLE_BACK = require("../../images/bg/sichengtitleback.png");
const VSIMG = require("../../images/icons/vsb.png");

const ICON_RECOMM = require('../../images/icons/tuijian.png');
const ICON_HOT = require("../../images/icons/remenr.png");
const PLAYICON = require("../../images/icons/living.gif");

const ICON_SOURCE = require("../../images/icons/ic_nami_soruce.png");

const ICON = require("../../images/icons/shaixuan.png");

class SubscribeMatch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            leagueData: [],
            hotData: [],
            value: 0,
            selectedIndex: 0,
            matchNums: 0,
        };
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 8,
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'SubscribeMatch');
        this.starLeague();
        this.getHotMatch();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    starLeague = async () => {
        if (!AppData.me.isLogin()) {
            return;
        }
        let result = await Apis.encryptionShowFocusLeague();
        console.log('starLeague', result);
        if (result.code == 200) {
            let matchNums = 0;
            for (let i = 0; i < result.data.length; i++) {
                matchNums += result.data[i].match.length;
            }
            let data = result.data.sort((a, b) => {
                return b.match.length - a.match.length;
            })
            this.setState({ leagueData: data, matchNums: matchNums });
        }
    }

    getHotMatch = async () => {
        let result = await Apis.encryptionRecommMatch();
        console.log('getHotMatch', result);
        if (result.code == 200) {
            this.setState({ hotData: result.data });
        }
    }

    _onItemClick = (val) => {
        this.setState({ selectedIndex: val })
    }

    _onClickMdy = () => {
        this.props.history.push('/subscribechannel');
    }

    _onClickLogin = () => {
        this.props.history.push('/login');
    }

    _renderNoLogin() {
        const { classes } = this.props;
        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' style={{ height: '26vw' }}>
                <Typography style={{ fontSize: 12, color: '#878787' }}> 登录后可查看关注联赛 </Typography>
                <ButtonBase onClick={() => this._onClickLogin()} className={classes.loginButton}>去登录</ButtonBase>
            </Grid>
        );
    }

    _renderLogin() {
        const { classes } = this.props;
        const { matchNums } = this.state;
        return (
            <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ marginTop: 12 }}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                    <Typography style={{ fontSize: 14, color: '#0D0D0D', fontWeight: 'bold', marginLeft: 8 }}>我关注的联赛</Typography>
                    <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 4 }}>{"近期共" + matchNums + "场"}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1 }}>
                    <ButtonBase onClick={() => this._onClickMdy()} className={classes.dyButton}>修改</ButtonBase>
                </Grid>
            </Grid>
        );
    }
    showPlay = (data) => {
        if (!data.nami) {
            return false;
        }
        if (data.nami.length == 0) {
            return false;
        }
        let liveSource = '';
        data.nami.forEach(element => {
            if (element.live_url.length > 0) {
                liveSource = element.live_url;
            }
        });
        return liveSource.length > 0;
    }

    renderItem = (data, i) => {
        const { classes, line } = this.props;
        let match = new Match(data);

        let status = match.getStatus();
        let timer = DateUtils.dateFormatHM(data.match_time);
        let vs = match.getVs();
        let star = AppData.isStarMatch(match.type_id, match.id);
        let showPlay = this.showPlay(match);
        let showAnchor = (match.host && match.host.length > 0 || match.nami && match.nami.length > 0);

        return (
            <Grid container direction='column'>


                <ButtonBase key={i} onClick={(e) => this._onClicAnchor(e, data)} style={{ marginTop: 2, marginBottom: 10 }} >
                    <Grid container justifyContent='space-between' alignItems='center' direction='column' className={classes.itemView} >
                        <Grid container alignItems='center' justifyContent='space-between' direction='row'>
                            <img src={data.is_hot == 1 ? ICON_HOT : ICON_RECOMM} style={{ width: 32, height: 15, marginLeft: 12 }}></img>
                        </Grid>
                        <Grid container alignItems='center' justifyContent='center' direction='row' style={{ flex: 1 }}>
                            <Grid container alignItems='center' direction='row' justifyContent='center' style={{ maxWidth: '40vw' }} >
                                <Typography style={{ fontSize: 11, color: '#222222' }}>{timer + '  '}</Typography>
                                <Typography style={{ fontSize: 11, color: '#222222', marginLeft: 8 }}>{data.competition_name}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={0} alignItems='center' justifyContent='center' direction='row' style={{ marginTop: 16, marginBottom: 15 }}>
                            {/* <img src={star ? ICON_SCT : ICON_SC} style={{ width: 12, height: 12, position: 'absolute', left: 16 }}></img> */}
                            <Grid container alignItems='center' justifyContent='space-between' direction='column' style={{ width: '30vw' }}>
                                <img src={data.home_log} className={classes.teamLogo}></img>
                                <Typography noWrap={true} style={{ fontSize: 12, color: '#0D0D0D', marginTop: 4, maxWidth: 96 }}>{data.home_name}</Typography>
                            </Grid>
                            <Grid container alignItems='center' justifyContent='center' direction='column' style={{ width: '30vw' }}>
                                {/* <Typography style={{ fontSize: 17, color: '#0D0D0D', fontWeight: 'bold' }}>{vs}</Typography> */}
                                {/* <img src={vsimg} style={{ width: 15, height: 15 }}></img> */}

                                {
                                    (vs == "VS") && <Grid>
                                        <img src={VSIMG} style={{ width: 25, height: 25 }}></img>
                                    </Grid>
                                }
                                {
                                    (vs != "VS") && <Typography style={{ fontSize: 17, color: '#0D0D0D', fontWeight: 'bold' }}>{vs}</Typography>
                                }
                                <Typography style={{ fontSize: 10, color: '#FF7D0A' }}>{status}</Typography>
                                {
                                    (!match.host || match.host.length == 0) && <Typography style={{ fontSize: 10, color: '#878787' }}>{match.getScoreVs()}</Typography>
                                }
                            </Grid>
                            <Grid container alignItems='center' justifyContent='center' direction='column' style={{ width: '30vw' }}>
                                <img src={data.away_log} className={classes.teamLogo}></img>
                                <Typography noWrap={true} style={{ fontSize: 12, color: '#0D0D0D', marginTop: 4, maxWidth: 96 }}>{data.away_name}</Typography>
                            </Grid>
                        </Grid>
                        {match.host && match.host.length != 0 && <Grid style={{ backgroundColor: '#E2E2E2', height: 1, width: 'calc(100vw - 48px)', marginLeft: 8, marginBottom: 8 }}></Grid>}
                        <Grid container alignItems='center' justifyContent='center' direction='row'>
                            {
                                match.host && match.host.length != 0 && <Grid container alignItems='center' justifyContent='center' direction='row'>
                                    {
                                        match.host && match.host.map((item, i) => (
                                            <Grid key={i} container alignItems='center' direction='column' onClick={(e) => this._onClicAnchor(e, item)} style={{ marginBottom: 8, maxWidth: 80 }} >
                                                <Avatar src={item.portrait} style={{ width: 32, height: 32, marginLeft: 4, marginRight: 4, }}></Avatar>
                                                <Grid className={classes.playIcon}>
                                                    {
                                                        item.live_status == Live.STATUS_LIVE && <img src={PLAYICON} style={{ width: 10, height: 10 }}></img>
                                                    }
                                                </Grid>
                                                <Typography noWrap={true} style={{ fontSize: 11, color: '#0D0D0D', maxWidth: 80, marginTop: 4 }}>{item.nickName}</Typography>
                                            </Grid>
                                        ))
                                    }
                                    {
                                        showPlay && <Grid container alignItems='center' justifyContent='center' direction='column' style={{ marginBottom: 8, maxWidth: 80 }}>
                                            <img src={ICON_SOURCE} style={{ width: 32, height: 32 }}></img>
                                            <Typography noWrap={true} style={{ fontSize: 11, color: '#0D0D0D', marginTop: 8 }}>视频源</Typography>
                                        </Grid>
                                    }
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </ButtonBase >
                <div style={{ width: "100%", height: 5, backgroundColor: '#F5F5F5' }}></div>
            </Grid>
        );
    }
    _onClicAnchor = (e, data) => {
        let match = new Match(data);
        //是否直播中
        let isliving = match.living();
        //点击了赛程
        e.stopPropagation();
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.type_id ? data.type_id : 0;
        let match_id = data.id ? data.id : 0;
        let pData = { pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data }
        if (AppData.os == 'ios' && isliving && AppData.isMatch == 'sai') {

            if (window && window.webkit && window.webkit.messageHandlers) {
                let jsonStr = JSON.stringify(pData);
                // AppData.isMatch == 'sai'
                window.webkit.messageHandlers.TransParm.postMessage(jsonStr);
            }
        } else {
            this.props.history.push(pData);
        }
    }

    render() {
        const { classes } = this.props;
        const { leagueData, hotData, selectedIndex, matchNums } = this.state;
        let match = [];
        if (leagueData && leagueData.length > 0) {
            match = leagueData[selectedIndex].match
        }
        return (
            <Grid container direction='column' alignItems='center' style={{ flex: 1, backgroundColor: '#FFF' }}>
                <Grid container direction='column' alignItems='center' justifyContent='center'>
                    {
                        AppData.me.isLogin() ? this._renderLogin() : this._renderNoLogin()
                    }
                    <Grid container direction='row' alignItems='center' style={{ width: '100vw', paddingTop: 12, paddingBottom: 12 }}>
                        <Swiper {...this.params} >
                            {
                                leagueData.map((item, i) => (
                                    <Grid key={i} container alignItems='center' justifyContent='center' style={{ paddingLeft: 12, width: 90 }}>
                                        <SubscribeItem selected={i == selectedIndex} onClick={() => this._onItemClick(i)} key={i} data={item} />
                                    </Grid>
                                ))
                            }
                        </Swiper>
                    </Grid>
                    <div style={{ width: "100%", height: 10, backgroundColor: '#F5F5F5' }}></div>
                    <Grid container direction='column' alignItems='center' style={{ width: '100vw', paddingTop: 12, paddingBottom: 12 }}>
                        {
                            match.length > 0 && match.map((item, i) => (
                                // <MatchItem key={i} data={match} line={true} />
                                this.renderItem(item, i)
                            ))
                        }
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ width: '100vw', paddingTop: 10, paddingBottom: 0 }}>
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ fontSize: 14, color: '#0D0D0D', fontWeight: 'bold', marginLeft: 8 }}>今日热门</Typography>
                            <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 8 }}>{DateUtils.dateFormatMD()}</Typography>
                        </Grid>
                    </Grid>
                    <div style={{ width: "100%", height: 10, backgroundColor: '#F5F5F5' }}></div>

                    <Grid container direction='column' alignItems='center' style={{ width: '100vw', paddingTop: 5, paddingBottom: 88 }}>
                        {
                            hotData.length > 0 && hotData.map((item, i) => (
                                // <MatchItem key={i} data={item} line={true} />
                                this.renderItem(item, i)
                            ))
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    playIcon: {
        width: 10,
        height: 10,
        margin: theme.spacing(-0.5, 0, 0, 0),
        zIndex: 1000,
    },
    titleView: {
        backgroundSize: 'cover',
        backgroundImage: `url(${ICON_TITLE_BACK})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        padding: theme.spacing(0, 1.5, 0, 1.5),
        width: '100vw',
        height: '8vw',
        marginBottom: theme.spacing(1)
    },
    arrow: {
        width: 10,
        height: 7
    },
    title: {
        fontSize: 12,
        color: '#878787'
    },

    teamLogo: {
        width: 45,
        height: 45,
        borderRadius: 30,
        border: '1px solid #cecece'
    },
    league: {
        padding: theme.spacing(0, 1, 0, 1)
    },
    itemView: {
        width: 'calc(100vw - 16px)',
        margin: theme.spacing(0, 1, 0, 1),
        backgroundColor: 'white',
        borderRadius: 10
    },
    dyButton: {
        minWidth: 64,
        backgroundColor: '#EDEAFD',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: theme.palette.primary.main,
        fontSize: 12,
        marginTop: 4,
    },
    loginButton: {
        minWidth: 64,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
        marginTop: 4,
    },
}))(SubscribeMatch));